var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.701,
    height: 15.577,
    viewBox: "0 0 15.701 15.577",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3171",
    "data-name": "Groupe 3171",
    transform: "translate(-1154 -491.423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-add-shopping-cart",
    "data-name": "Icon material-add-shopping-cart",
    d: "M6.173,14.74A1.558,1.558,0,1,0,7.731,16.3,1.556,1.556,0,0,0,6.173,14.74Zm7.788,0A1.558,1.558,0,1,0,15.519,16.3,1.556,1.556,0,0,0,13.961,14.74ZM6.305,12.209l.023-.093.7-1.269h5.8a1.55,1.55,0,0,0,1.363-.8L17.2,4.584l-1.355-.748h-.008l-.857,1.558-2.15,3.894H7.365l-.1-.21L5.519,5.394l-.74-1.558L4.047,2.279H1.5V3.836H3.058l2.8,5.911L4.81,11.656a1.506,1.506,0,0,0-.195.748,1.562,1.562,0,0,0,1.558,1.558h9.346V12.4H6.5A.2.2,0,0,1,6.305,12.209Z",
    transform: "translate(1152.5 489.145)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3170",
    "data-name": "Groupe 3170",
    transform: "translate(3 0.923)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Ligne_309",
    "data-name": "Ligne 309",
    x2: 6,
    transform: "translate(1156.5 493.5)",
    fill: "none",
    stroke: "#ebdcbd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_310",
    "data-name": "Ligne 310",
    x1: 6,
    transform: "translate(1159.5 490.5) rotate(90)",
    fill: "none",
    stroke: "#ebdcbd",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.f6392c97c6b19eb729ee7aa0584dddbe.svg";
export { ForwardRef as ReactComponent };